import React, { useMemo } from "react";
import { BellFilled } from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";
import { normalizeVisitorUniqueId } from "../../helpers/visitorId";
import "./HeaderNotification.css";

const visitorLabel = (invite) => {
  const name = String(invite?.visitorData?.name || "").trim();
  const id = normalizeVisitorUniqueId(invite?.visitorData?.unique_id);
  return name || (id ? `#${id}` : "Unknown visitor");
};

const HeaderNotification = ({ pendingTransfers = [], onAccept, onReject }) => {
  const items = useMemo(() => {
    if (!pendingTransfers?.length) {
      return [
        {
          key: "empty",
          label: (
            <div className="visitor_reminder_noti">
              <p>No pending chat transfers</p>
            </div>
          ),
          disabled: true,
        },
      ];
    }

    return pendingTransfers.map((invite, index) => {
      const uid = normalizeVisitorUniqueId(invite?.visitorData?.unique_id) || String(index);
      const fromName = invite?.senderData?.name || "an agent";
      return {
        key: `transfer-${uid}`,
        label: (
          <div
            className="visitor_transfer_noti"
            onClick={(e) => e.stopPropagation()}
          >
            <p>
              <strong>{fromName}</strong> wants to transfer visitor{" "}
              <strong>{visitorLabel(invite)}</strong> to you.
            </p>
            <div className="bottom_btn">
              <Button
                type="primary"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onAccept?.(invite);
                }}
              >
                Accept
              </Button>
              <Button
                type="dashed"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  onReject?.(invite);
                }}
              >
                Reject
              </Button>
            </div>
          </div>
        ),
      };
    });
  }, [pendingTransfers, onAccept, onReject]);

  const count = pendingTransfers?.length || 0;

  // Only show the bell when this agent has at least one pending transfer.
  if (count === 0) {
    return null;
  }

  return (
    <Dropdown
      menu={{ items }}
      trigger={["click"]}
      className="header_noti_main"
      overlayClassName="header_noti_mains"
      placement="bottomRight"
    >
      <a onClick={(e) => e.preventDefault()} style={{ position: "relative" }} aria-label="Transfer notifications">
        <div className="noti_count">
          <p>{count > 9 ? "9+" : count}</p>
        </div>
        <Space>
          <BellFilled />
        </Space>
      </a>
    </Dropdown>
  );
};

export default HeaderNotification;
